import { Fragment, ReactElement } from "react";
import { eventInfo , attachments } from '../../types/common';

interface detailprops {
	detail: eventInfo;
	attachments?: attachments[];
	isActive: boolean;
	setIsActive: (boolean: boolean) => void;
}

/**
	  * イベント詳細情報を表示するコンポーネント
	  * 
	  * @returns 
	  */

export function EventDetail(props: detailprops): ReactElement<detailprops> {

	/**
	  * MM-DD形式の日付をYYYY年MM月DD日のフォーマットに直す関数
	  * @param date 日付
	  * @returns string
	  */
	function dateFormatter(date: string): string {
		// 与えられた日付データを元にDateを宣言
		const d = new Date(date);
		// ja-JPフォーマットで年月日のstringに変換
		return d.toLocaleDateString("ja-JP", { year: "numeric", month: "short", day: "numeric" });
	}

	return (
		<div className="l-record">
			<div className="record-list">
				<div className="record-title-box">
					<h3 className="title">
						{props.detail.icon_class ?
							(<i className={props.detail.icon_class}></i>)
							:
							(<>
								<i className="ic-others">
									<img
										src={`data:${props.detail.mime_type};base64,${props.detail.attachment_url}`}
										alt="" />
								</i>
							</>)}
						<span className="txt">{props.detail.subject}</span>
					</h3>
				</div>
				<div className="record-set col1">
					<dl>
						<dt>イベント種別</dt>
						<dd>{props.detail.event_type_name}</dd>
					</dl>
				</div>
				<div className="record-set col1">
					<dl>
						<dt>開催日時</dt>
						<dd>{dateFormatter(props.detail.date)} {props.detail.from_time?.slice(0, 5)}～{props.detail.to_time?.slice(0, 5)}（受付開始 {props.detail.reception_time?.slice(0, 5)}～）</dd>
					</dl>
				</div>
				<div className="record-set col1">
					<dl>
						<dt>申込期限</dt>
						<dd>{dateFormatter(props.detail.limit_date)} ～{props.detail.limit_time?.slice(0, 5)}</dd>
					</dl>
				</div>
				<div className="record-set col1">
					<dl>
						<dt>参加可能人数</dt>
						<dd>{props.detail.limit_member}人</dd>
					</dl>
				</div>
				<div className="record-set col1">
					<dl>
						<dt>開催場所名</dt>
						<dd>{props.detail.location}</dd>
					</dl>
				</div>
				<div className="record-set col1">
					<dl>
						<dt>開催住所</dt>
						<dd>
							{props.detail.place}
							<br></br>
							TEL: {props.detail.phone_number}
						</dd>
					</dl>
				</div>
				<div className="record-set col1">
					<dl>
						<dt>会員参加費</dt>
						<dd>{props.detail.member_fee === 0 ? "無料" : props.detail.member_fee + '円'}</dd>
					</dl>
				</div>
				<div className={`${props.isActive === true ? "is-active" : ""}`}>
					<div className="detail-area" id="detail-area">
						<div className="record-set col1">
							<dl>
								<dt>内容</dt>
								<dd>{props.detail.contents}</dd>
							</dl>
						</div>
						<div className="record-set col1">
							<dl>
								<dt>振込口座</dt>
								<dd>{props.detail.bank_branch}<br />
									{props.detail.transfer_method}{props.detail.bank_account_address}<br />
									{props.detail.bank_account_name}</dd>
							</dl>
						</div>
						<div className="record-set col1">
							<dl>
								<dt>振込期限</dt>
								<dd>{props.detail.limit_bank_date} ～{props.detail.limit_bank_time}</dd>
							</dl>
						</div>
						<div className="record-set col1">
							<dl>
								<dt>添付ファイル</dt>
								<dd>
									{(props.attachments?.length !== 0) ?
										props.attachments?.map((attachment, index) => (
											<Fragment key={index}>
												<a href={`data:${attachment.mime_type};base64,${attachment.url}`}
													type={`${attachment.mime_type}`}
													download={`${attachment.filename}`}>
													{attachment.filename}
												</a>
												{(props.attachments) && (index + 1 < props.attachments.length) && ", "}
											</Fragment>
										))
										: "添付ファイルがありません"
									}
								</dd>
							</dl>
						</div>
					</div>
					<button type="button"
						className="btn-detail btnsz-auto js-acd-trigger"
						onClick={() => props.setIsActive(!props.isActive)}>
						<i
							className="ic-minus"></i>
						<span>詳細</span></button>
				</div>
			</div>
		</div>
	)
}